export enum DispatchRoles {
  PREVIEWER = 'roles.dispatchPreviewer',
  VIEWER = 'roles.dispatchViewer',
}
